/**
 * Lightweight query helpers that replace the array-query library.
 * Each function is a pure utility operating on plain arrays of objects.
 */

/** Compare two objects by a single field. Returns -1, 0, or 1. Null/undefined values are always sorted to the end. */
export function compareByField(a, b, key, dir = "ASC") {
  const aVal = a[key];
  const bVal = b[key];
  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return 1;
  if (bVal == null) return -1;
  if (aVal < bVal) return dir === "ASC" ? -1 : 1;
  if (aVal > bVal) return dir === "ASC" ? 1 : -1;
  return 0;
}

/** Sort an array of objects by a single field ascending or descending.
 * Null, undefined, and empty string values are always placed at the end. */
export function sortByField(arr, key, dir = "ASC") {
  return [...arr].sort((a, b) => {
    const aEmpty = a[key] === "";
    const bEmpty = b[key] === "";
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;
    return compareByField(a, b, key, dir);
  });
}

/**
 * Filter to objects where `field` contains any of `vals`.
 * Works for both array fields (via Array.includes) and string fields (via String.includes).
 * Objects where the field is null or undefined are excluded.
 */
export function filterByFieldHas(arr, field, vals) {
  const valArr = Array.isArray(vals) ? vals : [vals];
  return arr.filter(material => {
    const fieldVal = material[field];
    return fieldVal != null && valArr.some(v => fieldVal.includes?.(v));
  });
}

/**
 * Filter to objects where the value of `field` is strictly equal to one of the given `vals`.
 * Uses a Set internally for O(1) lookup.
 */
export function filterByFieldWithin(arr, field, vals) {
  const valSet = new Set(vals);
  return arr.filter(material => valSet.has(material[field]));
}
